<header class="paragraph-content-header text-center">
  <h1 class="page-title">Welcome!</h1>
</header>

<section class="mt-3 text-center lato">
  <p class="teal">
    To get the most out of your account, please take a moment to complete<br />
    your profile.
  </p>
  &nbsp;
  <p class="teal">
    Completing your profile will also ensure we always know how to <br />
    contact you about your Camper.
  </p>
  &nbsp;
  <p class="teal">First, answer a quick question and then click “<span style="color: #CD0000">Begin</span>” to get
    started!</p>
</section>
&nbsp;

<app-content-header text="We want to know!"></app-content-header>
<section class="text text-left">
  <p class="lato">How did you hear about Camp Bow Wow<sup>&#174;</sup>?&#xa;(Select all that apply.)</p>
  &nbsp;
  <div class="d-flex flex-column">
    <div *ngFor="let question of questions$ | async">
      <mat-checkbox
        (change)="selectOption(question.id)"
        color="primary"
      >
        {{ question.name }}
      </mat-checkbox>
    </div>
  </div>
</section>
<hr />